export default "/images/577c8b41f635a1d4a5da47dbec53ed14.avif";